import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

import { preliquidationChildrenRoutes } from './preliquidationChildrenRoutes';

const NotFoundPage = lazy(() => import('../../pages/404NotFound').then(module => ({ default: module.NotFound })));
const AutomaticRejectDebits = lazy(() => import('../../pages/collection').then(module => ({ default: module.AutomaticRejectDebits })));
const PolicyOverdueDebtListPage = lazy(() => import('../../pages/collection').then(module => ({ default: module.PolicyOverdueDebtListPage })));

interface RouteItem {
  path: string;
  element: JSX.Element;
}

const preliquidationRoutes = {
  path: '/cobranzas',
  element: <Outlet />,
  errorElement: <NotFoundPage />,
  children: [
    ...preliquidationChildrenRoutes.map(({ path, element }: RouteItem) => ({
      path,
      element,
    })),
    {
      path: 'rechazo-debitos-automaticos',
      element: <AutomaticRejectDebits title='Rechazos de débitos automaticos' />,
    },
    {
      path: 'polizas-deuda-vencida',
      element: <PolicyOverdueDebtListPage title='Pólizas con Deuda Vencida' />,
    }
  ],
};

export default preliquidationRoutes;
